const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the group category handler directive
 * @argument {Application} Application injected to gain access to the global Application service
 */
app.directive('groupCategories', ['Authorization', 'Categories', '$q', function (Authorization, Categories, $q) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      group: '='
    },
    template: require('../../../templates/directives/groups/group-categories.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;

      self.info = {
        selections: [],
        loading: false,
        loaded: false,
        listOptions: ['locations', 'departments', 'teams', 'grades', 'org_levels'],
        singularOptionMap: {
          location: 'locations',
          department: 'departments',
          team: 'teams',
          grade: 'grades',
          org_level: 'org_levels'
        },
        categories: {},
        legacyName: function(item) {
          var parentName;
          var papaName;

          item.text = item.name;
          item.lineage_ids = [item._id];

          if (item.parent && item.parent.name) {
            parentName = item.parent.name + ' -> ';
            item.text = parentName + item.text;
          }

          if (item.parent && item.parent.parent && item.parent.parent.name) {
            papaName = item.parent.parent.name + ' -> ';
            item.text = papaName + item.text;
          }
        },
        setSelections: function() {
          var list = [];
          self.info.listOptions.forEach(function(item) {
            if ($scope.group[item] && $scope.group[item].length) {
              list = list.concat($scope.group[item]);
            }
          });

          self.info.selections = list;
        }
      };

      self.removeSelection = function (type, item) {
        if (!item) {
          return;
        }

        if ($scope.group[type] && $scope.group[type].length) {
          for (var i = 0; i < $scope.group[type].length; i++) {
            var current = $scope.group[type][i];
            if (current === item) {
              $scope.group[type].splice(i, 1);
              self.info.setSelections();
              return;
            }
          }
        }

      };

      self.addItem = function(item) {
        if (!item || !item.item || !item.item._id) {
          return;
        }
        for (var key in self.info.singularOptionMap) {
          if (item.item[key] && $scope.group[self.info.singularOptionMap[key]]) {
            var checking = [].concat($scope.group[self.info.singularOptionMap[key]]);
            checking.push(item.item._id);

            self.info.loading = true;

            $q.all([Categories.trimSelections({}, {selections: checking}).$promise, Categories.multipleGet({}, {_ids: [item.item._id]}).$promise])
            .then(function(results) {
              var trimmedResults = results[0] || [];
              var singleItem = results[1] && results[1].length && results[1][0] || [];

              $scope.group[self.info.singularOptionMap[key]] = trimmedResults.slice(0);

              if (singleItem.name) {
                self.info.legacyName(singleItem);
                self.info.categories[singleItem._id] = singleItem;
              }

              self.info.setSelections();
              self.info.loading = false;
            }).catch(function(error) {
              self.info.loading = false;
              console.log('Error in adding additional category selection: ', error);
            });

            return;
          }
        }
      };

      self.init = function() {
        var options = [];

        self.info.listOptions.forEach(function(item) {
          if ($scope.group[item] && $scope.group[item].length) {
            options = options.concat($scope.group[item]);
          }
        });

        if (!options.length) {
          self.info.loaded = true;
          return;
        }

        self.info.loading = true;

        Categories.multipleGet({}, {_ids: options}).$promise
        .then(function(results) {
          results.forEach(function(cat) {
            self.info.legacyName(cat);
            self.info.categories[cat._id] = cat;
          });

          self.info.setSelections();
          self.info.loading = false;
          self.info.loaded = true;
        }).catch(function(error) {
          console.log('error', error);
        });
      };

      self.init();

    }],
    controllerAs: 'groupItems'
  };
}]);